<!-- Поле номера с быстрым доступом к настройкам нумератора. -->
<template>
  <div class="numerator-field">
    <BaseFormField
      :label="label"
      :for-id="inputId"
      :required="required"
      :filled="filled"
      :error="invalid && Boolean(errorText)"
      :error-message="errorText"
    >
      <template #action>
        <BaseActionLink @click="isNumeratorModalVisible = true">
          Нумератор
        </BaseActionLink>
      </template>

      <base-input
        :id="inputId"
        :model-value="modelValue"
        :type="type"
        :class="inputClass"
        :editable="editable"
        :invalid="invalid"
        :placeholder="placeholder"
        @update:modelValue="handleInput"
        @input="$emit('input', $event)"
      />
    </BaseFormField>

    <NumeratorSettingsModal
      v-if="isNumeratorModalVisible"
      :target-model="targetModel"
      :target-field="targetField"
      @close="isNumeratorModalVisible = false"
    />
  </div>
</template>

<script>
import NumeratorSettingsModal from "@/components/NumeratorSettingsModal.vue";

export default {
  name: "NumeratorField",

  components: {
    NumeratorSettingsModal,
  },

  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "Номер",
    },
    targetModel: {
      type: String,
      required: true,
    },
    targetField: {
      type: String,
      default: "number",
    },
    inputId: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
  },

  emits: ["input", "update:modelValue"],

  data() {
    return {
      isNumeratorModalVisible: false,
    };
  },

  methods: {
    handleInput(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>

<style scoped>
.numerator-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
}

.numerator-field :deep(.input-wrapper),
.numerator-field :deep(.input) {
  min-width: 0;
  width: 100%;
}

</style>
